module.exports = __webpack_public_path__ + "files/a6d11658ca6e2641599bb40832de2b1e.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/objects-1.png
// module id = 521
// module chunks = 76